// import external dependencies
/* eslint-disable */

import Scrollbar from "smooth-scrollbar";
import StopPlugin from "./stopScroll";
import gsap from "gsap";
import { CSSRulePlugin } from "gsap/CSSRulePlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import "./search-results";

gsap.registerPlugin(CSSRulePlugin, ScrollTrigger);

// import local dependencies
import Router from "./util/Router";
import common from "./routes/common";
import home from "./routes/home";
import aboutUs from "./routes/about";

const GOLDEN_RATIO = (1 + Math.sqrt(5)) / 2;
const RECIPROCAL_GR = 1 / GOLDEN_RATIO;
const DURATION = RECIPROCAL_GR;

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
window.onload = function () {
  routes.loadEvents();

  const container = document.querySelector(".main-scrolling-container");
  const main = document.querySelector("main");
  const titles = document.querySelectorAll(".a__title");
  const titlesSibling = titles[0] && titles[0].parentElement.nextElementSibling;
  const isPitch = window.location.pathname === "/pitch/";

  if (isPitch) {
    Scrollbar.destroyAll();
    document.body.style.overflow = "auto";
  }

  if (window.location.pathname !== "/pitch/") {
    Scrollbar.use(StopPlugin);

    let bodyScrollBar = Scrollbar.init(document.body, {
      damping: 0.1,
      delegateTo: document,
    });

    bodyScrollBar.setPosition(0, 0);
    bodyScrollBar.track.xAxis.element.remove();

    ScrollTrigger.scrollerProxy(container, {
      scrollTop(value) {
        if (arguments.length) {
          bodyScrollBar.scrollTop = value;
        }
        return bodyScrollBar.scrollTop;
      },
      getBoundingClientRect() {
        return {
          top: 0,
          left: 0,
          width: window.innerWidth,
          height: window.innerHeight,
        };
      },
    });

    bodyScrollBar.addListener(ScrollTrigger.update);
  }

  // Main Entrance
  const tl = gsap.timeline({
    defaults: { duration: DURATION, ease: "sine.out" },
  });

  if (!titlesSibling) {
    tl.set(main, { autoAlpha: 0 });
    tl.to(main, {
      delay: DURATION / 3,
      autoAlpha: 1,
      ease: "sine.out",
    });
  } else {
    tl.set(main, { autoAlpha: 0 });
    tl.set([titles, titlesSibling], { autoAlpha: 0, translateY: 20 });

    tl.to(main, {
      delay: DURATION / 3,
      autoAlpha: 1,
      ease: "sine.out",
    });

    tl.to([titles, titlesSibling], {
      translateY: 0,
      autoAlpha: 1,
      ease: "sine.out",
      stagger: 0.2,
    });

    gsap.to(titles, {
      scrollTrigger: {
        trigger: titles,
        start: "top 10%",
        end: "300%",
        scrub: true,
        scroller: container,
      },
      y: (i, target) =>
        -ScrollTrigger.maxScroll(window) * (target.dataset.speed * 0.075),
      ease: "none",
    });
  }

  // END Main Entrance

  // Timers
  const timers = document.querySelectorAll(".timer");

  if (timers) {
    timers.forEach((item) => {
      const from = { val: item.getAttribute("data-from") };
      const to = item.getAttribute("data-to");
      gsap.to(from, {
        scrollTrigger: {
          trigger: timers[0],
          start: "top 90%",
          end: "bottom 60%",
          scrub: true,
          scroller: container,
        },
        duration: DURATION,
        val: to,
        roundProps: "val",
        ease: "sine.out",
        onUpdate: function () {
          item.innerHTML = from.val;
        },
      });
    });
  }

  function landing() {
    let oldBodyScrollBar = Scrollbar.get(document.body);
    const landing = document.querySelector(".landing");
    const landingContent = document.querySelector(".landing__content");
    const landingContentH1 = document.querySelector(".landing__content h1");
    const svgs = document.querySelectorAll(".landing__svg");
    const header = document.querySelector("#main-header");
    const heading = document.querySelector(".landing__heading");
    const headingAfter = CSSRulePlugin.getRule(".landing__heading::after");

    const tl = gsap.timeline({
      defaults: {
        duration: DURATION,
        ease: "sine.out",
      },
      onStart: () => {
        oldBodyScrollBar.updatePluginOptions("modal", { scroll: false });
      },
      onComplete: () => {
        oldBodyScrollBar.updatePluginOptions("modal", { scroll: true });

        const heroImage = document.querySelector(".hero__image");
        if (heroImage) {
          gsap.set(heroImage, { transition: "none" });
          gsap.to(heroImage, {
            scrollTrigger: {
              trigger: heroImage,
              start: "top top",
              end: "bottom 40%",
              scrub: true,
              scroller: container,
            },
            y: (i, target) =>
              -ScrollTrigger.maxScroll(window) * (target.dataset.speed * 0.15),
            ease: "none",
          });
        }
        gsap.set("#main-header", {
          zIndex: 100,
        });
        ScrollTrigger.create({
          trigger: "#main-header",
          endTrigger: "#main-footer",
          pin: true,
          pinSpacing: false,
          scroller: container,
          scrub: true,
          onUpdate: (self) => {
            if (self.progress.toFixed(3) > 0.015) {
              gsap.to("#main-header", {
                duration: DURATION / 3,
                ease: "sine.out",
                paddingTop: "1rem",
                paddingBottom: "1rem",
                height: "auto",
                background: "white",
              });
            } else {
              gsap.to("#main-header", {
                duration: DURATION / 3,
                ease: "sine.out",
                paddingTop: "1.875rem",
                paddingBottom: "1.875rem",
                background: "transparent",
              });
            }
          },
        });
      },
    });

    tl.set(header, { autoAlpha: 0 });
    tl.set(landing, { overflow: "hidden" });
    tl.set([svgs, heading], { translateY: 60 });
    tl.to([heading, svgs], {
      delay: DURATION,
      translateY: 0,
      autoAlpha: 1,
      stagger: {
        each: 0.1,
        from: "start",
      },
    });
    tl.to(svgs, {
      translateY: -60,
      autoAlpha: 0,
      stagger: {
        each: 0.1,
        from: "end",
      },
    });
    tl.to(headingAfter, {
      cssRule: { height: 0 },
    });
    tl.to(
      landing,
      {
        height: 0,
      },
      `<${DURATION / 2.5}`
    );
    tl.to(header, { autoAlpha: 1 }, "<");
    tl.set([landingContent, landingContentH1], { zIndex: 20 });
  }

  if (document.body.classList.contains("home")) {
    landing();
  } else {
    gsap.set("#main-header", {
      zIndex: 100,
    });
    if (!isPitch) {
      ScrollTrigger.create({
        trigger: "#main-header",
        endTrigger: "#main-footer",
        pin: true,
        pinSpacing: false,
        scroller: container,
        scrub: true,
        onUpdate: (self) => {
          if (self.progress.toFixed(3) > 0.015) {
            gsap.to("#main-header", {
              duration: DURATION / 3,
              ease: "sine.out",
              paddingTop: "1rem",
              paddingBottom: "1rem",
              height: "auto",
              background: "white",
            });
          } else {
            gsap.to("#main-header", {
              duration: DURATION / 3,
              ease: "sine.out",
              paddingTop: "1.875rem",
              paddingBottom: "1.875rem",
              background: "transparent",
            });
          }
        },
      });
    } else {
      ScrollTrigger.create({
        trigger: "#main-header",
        endTrigger: "#main-footer",
        pin: true,
        pinSpacing: false,
        scrub: true,
        onUpdate: (self) => {
          if (self.progress.toFixed(3) > 0.015) {
            gsap.to("#main-header", {
              duration: DURATION / 3,
              ease: "sine.out",
              paddingTop: "1rem",
              paddingBottom: "1rem",
              height: "auto",
              background: "white",
            });
          } else {
            gsap.to("#main-header", {
              duration: DURATION / 3,
              ease: "sine.out",
              paddingTop: "1.875rem",
              paddingBottom: "1.875rem",
              background: "transparent",
            });
          }
        },
      });
    }
  }
};

document.addEventListener("DOMContentLoaded", () => {
  const pinSpacer = document.querySelector(".pin-spacer");
  if(pinSpacer){
    pinSpacer.style.top = '0px!important';
  }
  window.addEventListener("resize", () => {
    const icegram = document.querySelector(".ig_action_bar");
    if (icegram) {
      const height = icegram.offsetHeight;
      const pushdown = document.getElementById("ig_body_pushdown");
      if (pushdown) {
        pushdown.style.height = height + "px";
      }
    }
  });
});

/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/main.js